import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Grid, Navigation, Pagination } from "swiper";
import { textLengthFiltered } from "../utils/common";
import { hotSearchEatData } from "../data/hotSearch_eat.js";
import { hotSearchLiveData } from "../data/hotSearch_live.js";
import { hotSearchPlayData } from "../data/hotSearch_play.js";
import { hotSearchBuyData } from "../data/hotSearch_buy.js";
import HotSearchEatDefault from "../images/hotSearch_eat_default.jpg";
import HotSearchLiveDefault from "../images/hotSearch_live_default.jpg";
import HotSearchPlayDefault from "../images/hotSearch_play_default.jpg";
import HotSearchBuyDefault from "../images/hotSearch_buy_default.jpg";

const HotSearch = () => {
    const lists = [
        { id: "eat", type: "#潮好吃", data: hotSearchEatData, defaultImg: HotSearchEatDefault },
        { id: "live", type: "#潮好住", data: hotSearchLiveData, defaultImg: HotSearchLiveDefault },
        { id: "play", type: "#潮好玩", data: hotSearchPlayData, defaultImg: HotSearchPlayDefault },
        { id: "buy", type: "#潮好買", data: hotSearchBuyData, defaultImg: HotSearchBuyDefault }
    ];
    const [activeType, setActiveType] = useState(lists[2].id);
    const screenWidth = useRef(window.innerWidth).current;
    const swiperOptions = {
        slidesPerView: screenWidth > 767 ? 5 : 2.16,
        slidesPerGroup: screenWidth > 767 ? 2 : 1,
        spaceBetween: screenWidth > 767 ? 36 : 24,
        navigation: screenWidth > 767 ? true : false,
        centeredSlides: screenWidth > 767 ? false : true,
        pagination: screenWidth > 767 ? { clickable: true } : false
    };

    // 若圖片為 null，則將排序放置最後
    const changeOrder = (data) => {
        data.sort((a, b) => {
            if (b.image == null) {
                return -1;
            };
        });

        return data;
    };

    // 埋設 GA 點擊百大熱搜 tab 按鈕傳送參數
    const sendGaEventTab = (e) => {
        gtag("event", "Click", {
            "event_category": "Sheet",
            "event_label": e.currentTarget.dataset.label,
            "value": 1
        });
    };

    // 埋設 GA 點擊百大熱搜項目傳送參數
    const sendGaEventItem = (e) => {
        gtag("event", "Click", {
            "event_category": `Top${e.currentTarget.dataset.tabid}`,
            "event_label": `Top${e.currentTarget.dataset.tabid}${e.currentTarget.dataset.itemid}_click`,
            "value": 1
        });
    };

    return (
        <section id="hotSearch" className="hotSearch">
            <h2
                className="title"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
            >
                2023潮Way台南PIXNET百大熱搜指南
            </h2>
            <h3
                className="description"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
            >
                原來大家都在搜！這些熱搜景點你都去過了嗎？
            </h3>
            <ul
                className="tab container"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
                data-aos-delay="500"
            >
                {
                    lists && lists.map((list) => (
                        <li
                            key={list.id}
                            className={`${activeType === list.id ? "active" : ""}`}
                            onClick={(e) => {
                                setActiveType(list.id);
                                sendGaEventTab(e);
                            }}
                            data-label={`Sheet${list.id}_click`}
                        >
                            {list.type}
                        </li>
                    ))
                }
            </ul>
            <div
                className="hotSearch-slider container"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
                data-aos-delay="500"
            >
                <Swiper
                    modules={[Autoplay, Grid, Navigation, Pagination]}
                    slidesPerView={swiperOptions.slidesPerView}
                    slidesPerGroup={swiperOptions.slidesPerGroup}
                    spaceBetween={swiperOptions.spaceBetween}
                    navigation={swiperOptions.navigation}
                    pagination={swiperOptions.pagination}
                    autoplay={{ delay: 5000 }}
                    centeredSlides={swiperOptions.centeredSlides}
                    grid={{
                        rows: 2,
                        fill: "row"
                    }}
                >
                    {
                        lists.map((list) => (
                            list.id === activeType && changeOrder(list.data).map((item, i) => (
                                <SwiperSlide key={`${list.id}_${item.id}`} className="item">
                                    <a
                                        href={item.link}
                                        target="_blank"
                                        onClick={sendGaEventItem}
                                        data-tabid={list.id}
                                        data-itemid={item.id}
                                        rel="noreferrer"
                                    >
                                        <div className="hotSearch-img">
                                            <picture>
                                                <source media="(max-width: 1440px)" srcSet={item.imageSmall} />
                                                <img
                                                    loading="lazy"
                                                    src={item.image || list.defaultImg}
                                                    onError={(e) => {
                                                        e.currentTarget.src = list.defaultImg;
                                                    }}
                                                    alt="hotSearch-img"
                                                />
                                            </picture>
                                        </div>
                                        <h3 className="hotSearch-name">
                                            {textLengthFiltered(item.name, 9)}
                                        </h3>
                                    </a>
                                </SwiperSlide>
                            ))
                        ))
                    }
                </Swiper>
            </div>
        </section>
    );
};

export default HotSearch;
